import type { Ref } from 'vue'

import { uploadFile } from '@backmarket/nuxt-module-http/uploadFile'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import type {
  GetLegalDocumentsItem,
  LegalDocumentType,
} from '~/api/profile/types'
import { ROUTE_NAMES } from '~/constants/routes'

export function getHomeLink(hasCompletedOnboarding: boolean) {
  return hasCompletedOnboarding
    ? ROUTE_NAMES.PROFILE.HOME
    : ROUTE_NAMES.ONBOARDING.PROFILE.HOME
}

export function getCompanyInfoLink(hasCompletedOnboarding: boolean) {
  return hasCompletedOnboarding
    ? ROUTE_NAMES.PROFILE.COMPANY_INFO
    : ROUTE_NAMES.ONBOARDING.PROFILE.COMPANY_INFO
}

export function getLegalDetailsLink(hasCompletedOnboarding: boolean) {
  return hasCompletedOnboarding
    ? ROUTE_NAMES.PROFILE.LEGAL_DETAILS
    : ROUTE_NAMES.ONBOARDING.PROFILE.LEGAL_DETAILS
}

export function getContactDetailsLink(hasCompletedOnboarding: boolean) {
  return hasCompletedOnboarding
    ? ROUTE_NAMES.PROFILE.CONTACT_DETAILS
    : ROUTE_NAMES.ONBOARDING.PROFILE.CONTACT_DETAILS
}

export function getUserPermissionsLink(hasCompletedOnboarding: boolean) {
  return hasCompletedOnboarding
    ? ROUTE_NAMES.PROFILE.USER_PERMISSIONS
    : ROUTE_NAMES.ONBOARDING.PROFILE.USER_PERMISSIONS
}

export async function uploadLegalDocument(
  sellerId: number,
  file: File,
  type: LegalDocumentType,
  cancelPoll: Ref<(() => void) | undefined>,
) {
  const $httpFetch = useHttpFetch()
  const { status, handle: urlHandle } = await uploadFile(
    'onboarding_merchant_document',
    { sellerId },
    file,
    cancelPoll,
  )
  if (status === 'success') {
    return $httpFetch('/bm/merchants/profile/legal-documents', {
      method: 'POST',
      body: { urlHandle, type },
    })
  }

  return null
}

export async function deleteLegalDocument(id: GetLegalDocumentsItem['id']) {
  const $httpFetch = useHttpFetch()

  return $httpFetch('/bm/merchants/profile/legal-documents', {
    method: 'DELETE',
    body: { id },
  })
}
